"use strict";

exports.__esModule = true;

exports.default = function () {
  return {
    manipulateOptions: function manipulateOptions(opts, parserOpts) {
      parserOpts.plugins.push("flow");
    }
  };
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/babel-plugin-syntax-flow/lib/index.js
// module id = 926
// module chunks = 168707334958949